import { render, staticRenderFns } from "./upDialog.vue?vue&type=template&id=ae5afc0e&lang=pug&"
import script from "./upDialog.vue?vue&type=script&lang=js&"
export * from "./upDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports